/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgObjectG = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M16 5a3 3 0 1 1 1.714 2.711L16 9.426v2.91a5.646 5.646 0 0 0-1.636 1.826l-.004.007A6.161 6.161 0 0 0 13.696 16H9.403l-1.7 1.699a3 3 0 1 1-1.418-1.41L8 14.574V9.426L6.286 7.71A3 3 0 1 1 7.704 6.3L9.403 8h5.194l1.7-1.699A2.99 2.99 0 0 1 16 5zm3-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-5 6h-4v4h4zM5 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm0 14a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm14.704-.716v1.008l1.476.492v1.692c-.36.048-.728.072-1.104.072-.88 0-1.536-.248-1.968-.744-.424-.504-.636-1.26-.636-2.268 0-.904.244-1.596.732-2.076.496-.488 1.204-.732 2.124-.732.32 0 .64.028.96.084.32.048.684.136 1.092.264v-1.584a5.145 5.145 0 0 0-1.032-.288 6.227 6.227 0 0 0-1.092-.096c-.992 0-1.84.176-2.544.528a3.675 3.675 0 0 0-1.608 1.512c-.368.656-.552 1.452-.552 2.388 0 1.52.376 2.672 1.128 3.456.76.784 1.876 1.176 3.348 1.176 1.072 0 2.04-.2 2.904-.6v-4.284z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgObjectG as ObjectG };
